export default __webpack_public_path__ + "static/media/slider-wilo-1.48788a11.jpg";